import axios from "axios"

/** Les choix en attente de l'élève connecté : un tuteur a arrêté un créneau, la famille a 48 h, arrondies à l'heure pleine. */
function getTutorSlotMoves() {
    return axios.get(`api/v1/tutor-slot-moves`)
}

/**
 * Les créneaux du tuteur qui tiennent dans ceux de la famille. L'id passe par les paramètres
 * d'URL : c'est la clé que la feuille compare à la réponse (`useApiFetch` → `scopeUrlParams`).
 */
function getTutorSlotMoveOptions({}, {}, { id }) {
    return axios.get(`api/v1/tutor-slot-moves/${id}/options`)
}

/** `{ keys: [...] }` : autant de créneaux du tuteur qu'il y a d'heures à garder avec lui. */
function bookTutorSlotMove({ id }, data) {
    return axios.post(`api/v1/tutor-slot-moves/${id}/book`, data)
}

/** Garde ses créneaux (et le choix entier) avec un nouveau tuteur. */
function keepTutorSlotMove({ id }) {
    return axios.post(`api/v1/tutor-slot-moves/${id}/keep`)
}

/** Garde le tuteur pour l'autre matière de son bloc ; la matière libérée passe à un nouveau tuteur. */
function splitTutorSlotMove({ id }) {
    return axios.post(`api/v1/tutor-slot-moves/${id}/split`)
}

export const tutorSlotMovesService = {
    getTutorSlotMoves,
    getTutorSlotMoveOptions,
    bookTutorSlotMove,
    keepTutorSlotMove,
    splitTutorSlotMove,
}
